import { Coins } from "lucide-react";
import { TableCard } from "./TableCard";
import type { TableSummary } from "@/features/poker/hooks/useTableLobby";

const BLIND_LEVELS = [
  { sb: 5, bb: 10 },
  { sb: 10, bb: 20 },
  { sb: 25, bb: 50 },
  { sb: 50, bb: 100 },
  { sb: 100, bb: 200 },
];

interface CashLobbyProps {
  tables: TableSummary[];
  onJoin: (table: TableSummary) => void;
  joining?: boolean;
}

export const CashLobby = ({ tables, onJoin, joining }: CashLobbyProps) => {
  const cashTables = tables.filter((t) => t.gameMode === "cash");

  return (
    <div className="space-y-4">
      {BLIND_LEVELS.map((level) => {
        const levelTables = cashTables.filter(
          (t) => t.sb === level.sb && t.bb === level.bb
        );
        if (levelTables.length === 0) return null;

        return (
          <div key={`${level.sb}-${level.bb}`}>
            <div className="flex items-center gap-2 mb-2">
              <Coins className="w-4 h-4 text-green-400" />
              <h3 className="text-sm font-semibold text-muted-foreground">
                {level.sb}/{level.bb} Blinds
                <span className="ml-2 font-normal">
                  · Buy-in {(level.bb * 40).toLocaleString()}–{(level.bb * 150).toLocaleString()}
                </span>
              </h3>
            </div>
            <div className="space-y-2">
              {levelTables.map((table) => (
                <TableCard
                  key={table.room}
                  table={table}
                  onJoin={() => onJoin(table)}
                  joining={joining}
                />
              ))}
            </div>
          </div>
        );
      })}
      {cashTables.length === 0 && (
        <p className="text-center text-sm text-muted-foreground py-6">
          No cash tables available
        </p>
      )}
    </div>
  );
};
